import { BookingPill } from "PFApp/components/pills/booking_pill";
import { Typography } from "PFComponents/typography";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { AccessLevel, Booking } from "PFTypes";

import css from "./booking_category_column.module.scss";

const DENSE_MODE_WIDTH = 60;
const WIDE_MODE_WIDTH = 120;

type BookingCategoryColumnProps = {
  booking: Booking & { disabled?: boolean };
  isDense?: boolean;
};

export const BookingCategoryColumn = ({ booking, isDense }: BookingCategoryColumnProps) => {
  const { getCategory } = useBookingCategories();
  const category = getCategory(booking);
  const isCategoryHidden = !category || category.bookings_permissions === AccessLevel.Hidden;

  return (
    <BookingPill
      category={!isCategoryHidden ? category : undefined}
      className={css.root}
      style={{
        maxWidth: isDense ? DENSE_MODE_WIDTH : WIDE_MODE_WIDTH,
        width: "80%",
        borderWidth: 1,
        opacity: booking.disabled ? 0.5 : 1
      }}
      iconSize="xxs"
    >
      <Typography withMargin variant="labelRegular" textOverflow="clip">
        {category?.display_as ?? ""}
      </Typography>
    </BookingPill>
  );
};
